import { common, IOHelper, JSONHelper, utils, } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class PublicKeyContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.PublicKey;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfECPoint(this.value));
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = reader.readECPoint();
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBuffer() {
        return common.ecPointToBuffer(this.value);
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeECPoint(this.value);
    }
    serializeJSON(_context) {
        return {
            type: 'PublicKey',
            value: JSONHelper.writeECPoint(this.value),
        };
    }
}

//# sourceMappingURL=PublicKeyContractParameter.js.map
